interface ScrollToElementProps {
  element: HTMLElement;
  headerOffset: number;
}

export const scrollToElement = ({
  element,
  headerOffset,
}: ScrollToElementProps) => {
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.scrollY - headerOffset;
  window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
};
